export interface IMTicketDetails {
  email: string;
  mobile: string;
  startDate?: Date;
  verified?: boolean;
}
